module.exports = __webpack_public_path__ + "static/media/5_5.1f1651cb.png";